import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-material-test-summary-external',
    templateUrl: './material-test-summary-external.component.html',
    styleUrls: ['./material-test-summary-external.component.scss'],
    standalone: false
})
export class MaterialTestSummaryExternalComponent implements OnInit, OnDestroy {
  @Input() data: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
